import useAsyncData from "../../../hooks/use-async-data";
import orderForwardService from "../order-forward.service";
import OrderForwardList from "./order-forward-list";
import OrderForwardListParams from "./order-forward-list-params";

const useOrderForwardList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderForwardList>({ data: [], totalCount: 0 });

  const load = async (
    params: OrderForwardListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const OrderForwardList = await orderForwardService.getList(
        params,
        signal,
      );

      setData(OrderForwardList);
      setIsLoading(false);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useOrderForwardList;
